module.exports = __webpack_public_path__ + "assets/img/142.a8a1248e.png";